import React from 'react'

import * as S from './styled'

const PlainTextarea = React.forwardRef(({ label, value, onChange, ...restProps }, ref) => (
    <div className="form-group" data-testid={`${label.toLowerCase().replaceAll(' ', '-')}-section`}>
        {label && <label className="!mb-1">{label}</label>}
        <S.PlainTextarea
            className="form-control"
            value={value}
            onChange={onChange}
            ref={ref}
            {...restProps}
        />
    </div>
))

export default PlainTextarea
